import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ListboxModule } from 'primeng/listbox';
import { NgModule } from '@angular/core';
import { PhoneNumberComponent } from './phone-number.component';
import { TranslateModule } from '@ngx-translate/core';
import { InputMaskModule } from 'primeng/inputmask';

@NgModule({
  declarations: [PhoneNumberComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    ListboxModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    InputMaskModule
  ],
  exports: [PhoneNumberComponent]
})
export class PhoneNumberModule {}
